import { Suspense, useEffect, useState } from "react";
import { GenerationNavigationGuard } from "../components/navigation/GenerationNavigationGuard";
import { GenerationJobProvider } from "../providers/GenerationJobProvider";
import { TelemetryProvider } from "../components/telemetry/TelemetryProvider";
import { RouteTelemetryBridge } from "../components/telemetry/RouteTelemetryBridge";
import { ProtectedRoute } from "./ProtectedRoute";
import { RouteLoadingFallback } from "./RouteLoadingFallback";
import { resolveTemaRoute } from "./resolveTemaRoute";
import { RouteFallback } from "./RouteFallback";
import { TemaRouteProvider } from "./TemaRouteContext";

function useHashRoute() {
  const [hash, setHash] = useState(() => window.location.hash);

  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash);
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return hash;
}

export function TemaAppRoutes() {
  const hash = useHashRoute();
  const route = resolveTemaRoute(hash);
  const PageComponent = route.component;

  return (
    <TemaRouteProvider route={route} hash={hash}>
      <GenerationJobProvider>
        <GenerationNavigationGuard />
        <TelemetryProvider>
        <RouteTelemetryBridge route={route} hash={hash} />
        <ProtectedRoute route={route}>
        {PageComponent ? (
          <Suspense fallback={<RouteLoadingFallback />}>
            <PageComponent />
          </Suspense>
        ) : (
          <RouteFallback kind="not-found" hash={hash} />
        )}
        </ProtectedRoute>
        </TelemetryProvider>
      </GenerationJobProvider>
    </TemaRouteProvider>
  );
}
